import React from "react";

export const AIAgents = ({ data }) => {
  return (
    <div id="aiagents" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Advanced AI Agent Development</h2>
          <p>Explore our specialized AI agents tailored for complex industry needs.</p>
        </div>
        <div className="row">
          {data
            ? data.map((agent, index) => (
                <div key={`${agent.name}-${index}`} className="col-md-6">
                  <div className="service-item">
                    <h3>{agent.name}</h3>
                    <p>{agent.description}</p>
                  </div>
                </div>
              ))
            : "Loading..."}
        </div>
      </div>
    </div>
  );
};
